import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectedAccrualApi = {
    getProjectedAccrualByTrialId: (trialId: number): Observable<Dtos.GetProjectedAccrualByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectedAccrualByTrialId = new Dtos.GetProjectedAccrualByTrialId();

        request.trialId = trialId

        //Send request.
        const response: Promise<Dtos.GetProjectedAccrualByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getProjectedAccrualById: (id: number): Observable<Dtos.GetProjectedAccrualByIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectedAccrualById = new Dtos.GetProjectedAccrualById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetProjectedAccrualByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProjectedAccrual: (projectedAccrual: Dtos.ProjectedAccrual): Observable<Dtos.SetProjectedAccrualResponse> => {

        let request: Dtos.SetProjectedAccrual = new Dtos.SetProjectedAccrual();

        request.projectedAccrual = projectedAccrual;

        // send request
        const response: Promise<Dtos.SetProjectedAccrualResponse> = client.post(request);

        return Observable.from(response);

    },
    updateProjectedAccrual: (trialId: number, projectedAccruals: Dtos.ProjectedAccrual[]): Observable<Dtos.UpdateProjectedAccrualResponse> => {

        let request: Dtos.UpdateProjectedAccrual = new Dtos.UpdateProjectedAccrual();

        request.trialId = trialId;
        request.projectedAccruals = projectedAccruals;

        // send request
        const response: Promise<Dtos.UpdateProjectedAccrualResponse> = client.post(request);

        return Observable.from(response);

    }
}